/**
 * Frozen roll algorithm for challenge version 1.3.0.
 *
 * DO NOT EDIT once this version is live on-chain.
 * To change roll behavior, copy this file forward to the next version and edit only that copy.
 *
 * Compare with the previous version:
 *   diff -u www/packages/react-app/src/utils/rollers/<prev>.mjs www/packages/react-app/src/utils/rollers/v1_3_0.mjs
 */
import { getRandomItem, getRandomItemWeighted, seedRandomItem } from '../rollRng.mjs';

export const VERSION = '1.3.0';

/**
 * @param {string} seed block.hash
 * @param {object} challengeConfigVersion
 * @returns {{ version: string, mission: object, loadout: object, success: object }}
 */
export function roll(seed, challengeConfigVersion) {
  seedRandomItem(seed);
  const version = VERSION;

const selectedEnemy = getRandomItem(challengeConfigVersion.enemy);
const selectedTeamplay = getRandomItemWeighted(challengeConfigVersion.teamplay, challengeConfigVersion.teamplayWeights);

let selectedDifficulty = getRandomItem(challengeConfigVersion.difficulty);
while (!isValidDifficulty(selectedTeamplay, selectedDifficulty)) {
  selectedDifficulty = getRandomItem(challengeConfigVersion.difficulty);
}

const selectedDuration = getRandomItem(challengeConfigVersion.duration);

let selectedStars = getRandomItem(challengeConfigVersion.stars);
while (!isValidStars(selectedDifficulty, selectedStars)) {
  selectedStars = getRandomItem(challengeConfigVersion.stars);
}

let selectedPrimary, selectedSecondary, selectedGrenade,
selectedStratagem1, selectedStratagem2, selectedStratagem3, selectedStratagem4;

do {
  selectedPrimary = getRandomItem(challengeConfigVersion.primary);

  selectedSecondary = getRandomItem(challengeConfigVersion.secondary);
  while (!isValidSecondary(selectedTeamplay, selectedSecondary)) {
    selectedSecondary = getRandomItem(challengeConfigVersion.secondary);
  }

  selectedGrenade = getRandomItem(challengeConfigVersion.grenade);

  selectedStratagem1 = getRandomItem(challengeConfigVersion.SupportWeaponStratagems);
  selectedStratagem2 = getRandomItem(challengeConfigVersion.stratagem);
  while (!isValidStratagem([selectedStratagem1], selectedStratagem2, challengeConfigVersion, selectedEnemy, selectedSecondary)) {
    selectedStratagem2 = getRandomItem(challengeConfigVersion.stratagem);
  }

  selectedStratagem3 = getRandomItem(challengeConfigVersion.stratagem);
  while (!isValidStratagem([selectedStratagem1, selectedStratagem2], selectedStratagem3, challengeConfigVersion, selectedEnemy, selectedSecondary)) {
    selectedStratagem3 = getRandomItem(challengeConfigVersion.stratagem);
  }

  selectedStratagem4 = getRandomItem(challengeConfigVersion.stratagem);
  while (!isValidStratagem([selectedStratagem1, selectedStratagem2, selectedStratagem3], selectedStratagem4, challengeConfigVersion, selectedEnemy, selectedSecondary)) {
    selectedStratagem4 = getRandomItem(challengeConfigVersion.stratagem);
  }
} while (!hazDaBomb(
  selectedEnemy,
  selectedPrimary,
  selectedSecondary,
  selectedGrenade,
  selectedStratagem1,
  selectedStratagem2,
  selectedStratagem3,
  selectedStratagem4,
  challengeConfigVersion
));

return {
  version,
  mission: {
    enemy: selectedEnemy,
    difficulty: selectedDifficulty,
    duration: selectedDuration,
    teamplay: selectedTeamplay,
    stars: selectedStars,
  },
  loadout: {
    primary: selectedPrimary,
    secondary: selectedSecondary,
    grenade: selectedGrenade,
    stratagem1: selectedStratagem1,
    stratagem2: selectedStratagem2,
    stratagem3: selectedStratagem3,
    stratagem4: selectedStratagem4,
  },
  success: {
    stars: selectedStars,
  },
};
}

function isValidStratagem(selected, strat, config, selectedEnemy, selectedSecondary) {
  for (let i = 0; i < selected.length; i++) {
    if ((config.BackpackStratagems.includes(selected[i]) && config.BackpackStratagems.includes(strat)) ||
        (config.SupportWeaponStratagems.includes(selected[i]) && config.SupportWeaponStratagems.includes(strat)) ||
        ((config.VehicleStratagems || config.MechStratagems) && (config.VehicleStratagems || config.MechStratagems).includes(selected[i]) && (config.VehicleStratagems || config.MechStratagems).includes(strat)) ||
        selected[i] === strat) {
      return false;
    }
  }

  if ((selectedEnemy === "Terminid" && strat === "SH-20 Balistic Shield Backpack") ||
      (selectedEnemy === "Terminid" && strat === "FX-12 Shield Generator Relay") ||
      (selectedEnemy === "Terminid" && strat === "SH-51 Directional Shield")) {
    return false;
  }

  if ((selectedSecondary === "P-11 Stim Pistol" && strat === "SH-51 Directional Shield") ||
      (selectedSecondary === "P-11 Stim Pistol" && strat === "SH-20 Balistic Shield Backpack")) {
    return false;
  }

  return true;
}

function isValidStars(difficulty, stars) {
  if ((difficulty === "1 - Trivial or greater"      && stars === "3 stars or more") ||
      (difficulty === "1 - Trivial or greater"      && stars === "4 stars or more") ||
      (difficulty === "1 - Trivial or greater"      && stars === "5 stars") ||
      (difficulty === "2 - Easy or greater"         && stars === "3 stars or more") ||
      (difficulty === "2 - Easy or greater"         && stars === "4 stars or more") ||
      (difficulty === "2 - Easy or greater"         && stars === "5 stars") ||
      (difficulty === "3 - Medium or greater"       && stars === "4 stars or more") ||
      (difficulty === "3 - Medium or greater"       && stars === "5 stars") ||
      (difficulty === "4 - Challenging or greater"  && stars === "4 stars or more") ||
      (difficulty === "4 - Challenging or greater"  && stars === "5 stars") ||
      (difficulty === "5 - Hard or greater"         && stars === "5 stars") ||
      (difficulty === "6 - Extreme or greater"      && stars === "5 stars")) {
    return false;
  }

  return true;
}


function isValidDifficulty(teamplay, difficulty) {
  if ((teamplay === "Solo" && difficulty === "8 - Impossible or greater") ||
      (teamplay === "Solo" && difficulty === "9 - Helldive or greater") ||
      (teamplay === "Solo" && difficulty === "10 - Super Helldive")) {
    return false;
  }

  if ((teamplay === "Squad" && difficulty === "1 - Trivial or greater") ||
      (teamplay === "Squad" && difficulty === "2 - Easy or greater") ||
      (teamplay === "Squad" && difficulty === "3 - Medium or greater") ||
      (teamplay === "Squad" && difficulty === "4 - Challenging or greater")) {
    return false;
  }

  return true;
}


function isValidSecondary(teamplay, secondary) {
  if (teamplay === "Solo" && secondary === "P-11 Stim Pistol") {
    return false;
  }

  return true;
}


// this fuction ensures that there is always an answer to close an enemy spawner
function hazDaBomb(enemy, primary, secondary, grenade, strat1, strat2, strat3, strat4, config) {
  const stratagems = [strat1, strat2, strat3, strat4];

  // Check if any weapon can close enemy spawners using config data
  if (config.SpawnerWeapons && config.SpawnerWeapons[enemy]) {
    const factionWeapons = config.SpawnerWeapons[enemy];

    if (factionWeapons.primary && factionWeapons.primary.includes(primary)) {
      return true;
    }

    if (factionWeapons.secondary && factionWeapons.secondary.includes(secondary)) {
      return true;
    }

    if (factionWeapons.grenade && factionWeapons.grenade.includes(grenade)) {
      return true;
    }

    if (factionWeapons.stratagem) {
      for (const strat of stratagems) {
        if (factionWeapons.stratagem.includes(strat)) {
          return true;
        }
      }
    }
  }

  return false;
}

